import {createContext} from 'react';
export const ApiContext = createContext({});
export const StateContext = createContext({});
export const ForceUpdateContext = createContext({});
